<h2 mat-dialog-title>{{ data.name }}</h2>
<mat-dialog-content>
  <p>{{ data.description }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
